import { AutogenModelPnnEquipType, AutogenRowPnnEquipType } from "./autogen/AutogenModelPnnEquipType";

export class ModelPnnEquipType extends AutogenModelPnnEquipType<RowPnnEquipType> {
    constructor() {
        super(RowPnnEquipType);
    }
}

export class RowPnnEquipType extends AutogenRowPnnEquipType {
}